import { atomFamily } from "recoil";
import { ocPersistAtom } from "./persist-atom";
import { RoleFilterInput } from "oc/types";

export const ocRoleFiltersState = atomFamily<RoleFilterInput, string>({
  key: "ocRoleFiltersState",
  default: {
    company: [],
    orgUnit: [],
    workingPlace: [],
    jobClassGroup: [],
    payOffice: [],
    contract: [],
  },
  effects_UNSTABLE: [ocPersistAtom],
});
